import { FilterOperators, FilterTypes } from "@/data/table";
import i18n from "@/i18n";
import { ImportStatusCodes as ISC } from "@/data/enums/imports";
import { CreatedAtFilter } from "@/data/filters/object";

export const NameFilter = () => ({
  key: "name",
  label: i18n.t("_.name"),
  type: FilterTypes.STRING,
  operator: FilterOperators.CONTAINS
});

export const StatusFilter = () => ({
  key: "status.code",
  label: i18n.t("_.status"),
  type: FilterTypes.SELECT_CHECKBOX,
  options: [
    { value: ISC.PENDING, label: i18n.t("_.pending") },
    { value: ISC.EXPORTING, label: i18n.t("_.exporting") },
    { value: ISC.MAPPINGS_REQUIRED, label: i18n.t("_.mappings_required") },
    { value: ISC.IN_PROGRESS, label: i18n.t("_.in_progress") },
    { value: ISC.CANCELLED, label: i18n.t("_.cancelled") },
    { value: ISC.ERROR, label: i18n.t("_.error") },
    { value: ISC.STAGED, label: i18n.t("_.staged") },
    { value: ISC.COMPLETE, label: i18n.t("_.complete") }
  ],
  operator: FilterOperators.EQUAL
});

export const CredentialUrlFilter = () => ({
  key: "credentials.url",
  label: i18n.t("_.source"),
  type: FilterTypes.STRING,
  operator: FilterOperators.EQUAL
});

export const DefaultFilters = () => [
  NameFilter(),
  StatusFilter(),
  CredentialUrlFilter(),
  CreatedAtFilter()
];
